export default {
    account: 'บัญชี',
    mainAccount: 'บัญชีหลัก',
    organizationOfAccountDetails: 'โครงสร้างรายละเอียดของบัญชี',
    billingProfile: 'โปรไฟล์การเรียกเก็บเงิน',
    fullDetailsOfAccountProfile: 'รายละเอียดโปรไฟล์บัญชีทั้งหมด',
    idNumber: 'หมายเลขประจำตัว',
    website: 'เว็บไซต์',
    business: 'ธุรกิจ',
    fullAddressDetailsOfAccountInformation: 'รายละเอียดที่อยู่ทั้งหมดของข้อมูลบัญชี',

    updateProfile: 'อัปเดตโปรไฟล์',

};